<h2 mat-dialog-title>Share Rewatch Link</h2>

<mat-dialog-content>
  <p class="share-hint">
    Send the recording link by email to anyone who purchased a seat in this webinar.
  </p>

  <div *ngIf="recipients.length === 0" class="no-recipients">
    No purchasers found for this webinar yet.
  </div>

  <div *ngIf="recipients.length > 0">
    <mat-checkbox [checked]="allSelected" [indeterminate]="someSelected && !allSelected"
      (change)="toggleAll($event.checked)">
      Select All ({{ recipients.length }})
    </mat-checkbox>

    <div class="recipient-list">
      <div class="recipient-row" *ngFor="let recipient of recipients">
        <mat-checkbox [(ngModel)]="recipient.selected">
          <span class="recipient-name">{{ recipient.name }}</span>
          <span class="recipient-email" *ngIf="recipient.email">{{ recipient.email }}</span>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="error-message" *ngIf="errorMessage">{{ errorMessage }}</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="btn-cancel" (click)="onCancel()" [disabled]="sending">Cancel</button>
  <button type="button" class="btn-send" (click)="onShare()" [disabled]="!someSelected || sending">
    {{ sending ? 'Sending...' : 'Share' }}
  </button>
</mat-dialog-actions>
